import React from 'react';
import { styled } from '@mui/material/styles';
import { List } from '@mui/material';
import { Props } from './props';
import GroupTree from './tree';

const PREFIX = 'GroupsOverview';

const classes = {
  root: `${PREFIX}-root`,
};

const StyledList = styled(List)(({ theme }) => ({
  [`&.${classes.root}`]: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function GroupsOverview({
  groups,
  expanded,
  onClick,
}: Pick<Props, 'groups' | 'onClick' | 'expanded'>): JSX.Element {
  return (
    <StyledList className={classes.root}>
      <GroupTree
        groups={groups}
        expanded={expanded}
        level={0}
        onClick={onClick}
      />
    </StyledList>
  );
}
